const app = {
    'state': {
        'sideMenuList': [],
        'isMobile': false,
        'shouldShowCovid19Form': false
    },
    'mutations': {
        setSideMenuList (state, list) {
            state.sideMenuList = list;
        },
        setIsMobile (state, isMobile) {
            state.isMobile = isMobile;
        }
    }
};

export default app;
